import { type ComponentProps, type FC } from "react";
import { Button } from "@root/shared/components/Button";
import * as styles from "./styles.css";

type Props = {
  buttonProps: ComponentProps<typeof Button>;
};

// 単一選択モーダルのフッター。複数選択(アルバム)と異なりプラン枚数表示は不要で、確定ボタンのみ
export const SingleSelectFooter: FC<Props> = ({ buttonProps }) => (
  <div className={styles.container}>
    <Button {...buttonProps} theme="primary" className={styles.button}>
      画像を設定する
    </Button>
  </div>
);
